'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var reactElements = require('@selfdetermine/react-elements');
var reactHooks = require('@selfdetermine/react-hooks');
var graphql = require('@selfdetermine/graphql');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      query Hearings($date: String!) {\n        viewer {\n          hearings(date: $date) {\n            startedAt\n            kind\n            matter {\n              id\n              caseNumber\n              details: description\n              isSealed\n              judge {\n                email\n              }\n              adverseParties {\n                ... on Person {\n                  id\n                  firstName\n                  lastName\n                }\n              }\n              primaryCounsels {\n                name\n              }\n            }\n          }\n        }\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      query Hearing($id: ID!) {\n        viewer {\n          hearing(id: $id) {\n            id\n            kind\n            startedAt\n            matter {\n              description\n              caseNumber\n              isSealed\n            }\n          }\n        }\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var useHearing = function useHearing() {
  var _data$viewer;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      id = _ref.id;

  var _useQuery = reactHooks.useQuery(graphql.gql(_templateObject()), {
    variables: {
      id: id
    }
  }),
      data = _useQuery.data,
      meta = _objectWithoutProperties(_useQuery, ["data"]);

  return [data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.hearing, meta];
};
var useHearings = function useHearings(_ref2) {
  var _data$viewer2;

  var date = _ref2.date;

  var _useQuery2 = reactHooks.useQuery(graphql.gql(_templateObject2()), {
    variables: {
      date: date
    }
  }),
      data = _useQuery2.data,
      meta = _objectWithoutProperties(_useQuery2, ["data"]);

  return [(data === null || data === void 0 ? void 0 : (_data$viewer2 = data.viewer) === null || _data$viewer2 === void 0 ? void 0 : _data$viewer2.hearings) || [], meta];
};
var HearingCard = function HearingCard(_ref3) {
  var _hearing$matter, _hearing$matter2;

  var hearing = _ref3.hearing;
  return /*#__PURE__*/React__default['default'].createElement(reactElements.Card, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Card.Header, {
    title: [(_hearing$matter = hearing.matter) === null || _hearing$matter === void 0 ? void 0 : _hearing$matter.caseNumber, hearing.startedAt ? new Date(hearing.startedAt).toLocaleDateString() : null].filter(Boolean).join(" - ")
  }), /*#__PURE__*/React__default['default'].createElement(reactElements.Card.Content, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Columns, {
    multiline: true,
    mobile: true
  }, /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, null, /*#__PURE__*/React__default['default'].createElement("p", null, "Begin Date and Time:", " ", /*#__PURE__*/React__default['default'].createElement(DisplayDate, {
    date: hearing.startedAt,
    type: "long"
  })), /*#__PURE__*/React__default['default'].createElement("p", null, hearing.kind), hearing.matter && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("p", null, hearing.matter.caseNumber), /*#__PURE__*/React__default['default'].createElement("p", null, hearing.matter.description))), ((_hearing$matter2 = hearing.matter) === null || _hearing$matter2 === void 0 ? void 0 : _hearing$matter2.isSealed) && /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, {
    narrow: true
  }, /*#__PURE__*/React__default['default'].createElement("p", null, /*#__PURE__*/React__default['default'].createElement(reactElements.Tags, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Tags.Tag, {
    color: "danger"
  }, "Sealed")))))));
};
HearingCard.propTypes = {
  hearing: PropTypes__default['default'].shape({
    id: PropTypes__default['default'].number,
    kind: PropTypes__default['default'].string,
    startedAt: PropTypes__default['default'].string,
    matter: PropTypes__default['default'].shape({
      description: PropTypes__default['default'].string,
      caseNumber: PropTypes__default['default'].number,
      isSealed: PropTypes__default['default'].bool
    })
  })
};

var DisplayDate = function DisplayDate(_ref4) {
  var date = _ref4.date,
      type = _ref4.type;
  var options = {};

  if (!date) {
    return /*#__PURE__*/React__default['default'].createElement("span", {
      className: "has-text-grey"
    }, "N/A");
  }

  if (type === "long") {
    options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric"
    };
  } else if (type === "hours") {
    options = {
      hour: "numeric",
      minute: "numeric"
    };
  }

  return new Intl.DateTimeFormat("en-US", options).format(new Date(date));
};

var DocketTable = function DocketTable(_ref5) {
  var hearings = _ref5.hearings,
      date = _ref5.date;
  return /*#__PURE__*/React__default['default'].createElement(reactElements.Section, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Left, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Title, {
    size: "4"
  }, "Hearings Scheduled for ", date)), /*#__PURE__*/React__default['default'].createElement(reactElements.Level.Right, null, hearings.length, " Today")), /*#__PURE__*/React__default['default'].createElement(reactElements.Table, {
    fullwidth: true,
    className: "printable"
  }, /*#__PURE__*/React__default['default'].createElement(reactElements.Table.Row, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Table.Heading, null, "Begins at Date/Time")), hearings.map(function (hearing) {
    var _hearing$matter$adver, _hearing$matter$prima, _hearing$matter$judge, _hearing$matter3;

    return /*#__PURE__*/React__default['default'].createElement(reactElements.Table.Row, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Table.Cell, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Card, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Card.Content, null, /*#__PURE__*/React__default['default'].createElement(reactElements.Columns, {
      multiline: true,
      mobile: true
    }, /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, null, /*#__PURE__*/React__default['default'].createElement(DisplayDate, {
      date: hearing.startedAt,
      type: "long"
    }), /*#__PURE__*/React__default['default'].createElement("br", null), (_hearing$matter$adver = hearing.matter.adverseParties) === null || _hearing$matter$adver === void 0 ? void 0 : _hearing$matter$adver.map(function (party) {
      return /*#__PURE__*/React__default['default'].createElement("p", null, "".concat(party.firstName, " ").concat(party.lastName));
    }), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("p", null, hearing.kind), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("p", null, "Case: ", hearing.matter.caseNumber), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("p", null, "Prosecutor:", " ", ((_hearing$matter$prima = hearing.matter.primaryCounsels[0]) === null || _hearing$matter$prima === void 0 ? void 0 : _hearing$matter$prima.name) || "Unassigned")), /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, null, /*#__PURE__*/React__default['default'].createElement("p", null, "Judge: ", ((_hearing$matter$judge = hearing.matter.judge) === null || _hearing$matter$judge === void 0 ? void 0 : _hearing$matter$judge.email) || "Unassigned")), /*#__PURE__*/React__default['default'].createElement(reactElements.Columns.Column, null, /*#__PURE__*/React__default['default'].createElement("p", null, /*#__PURE__*/React__default['default'].createElement("strong", null, ((_hearing$matter3 = hearing.matter) === null || _hearing$matter3 === void 0 ? void 0 : _hearing$matter3.isSealed) ? "Sealed" : ""))))))));
  })));
};
DocketTable.propTypes = {
  hearings: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    hearing: PropTypes__default['default'].shape({
      id: PropTypes__default['default'].number,
      kind: PropTypes__default['default'].string,
      startedAt: PropTypes__default['default'].string,
      matter: PropTypes__default['default'].shape({
        description: PropTypes__default['default'].string,
        caseNumber: PropTypes__default['default'].number,
        isSealed: PropTypes__default['default'].bool
      })
    })
  })),
  date: PropTypes__default['default'].string
};

exports.DocketTable = DocketTable;
exports.HearingCard = HearingCard;
exports.useHearing = useHearing;
exports.useHearings = useHearings;
